import * as React from 'react';
import Theme from '../../../styles/Theme/Theme';
//import * as IconsLibrary from '../../../assets/icons/_index';
import * as IconsLibrary from './Library';


const CustomIcon = ({ icon, ...rest }) => {
    if (icon) {
        const windowSize = window.screen.width;
        const isVideowallMode =
            document.documentElement.dataset.displayMode === 'videowall' ||
            document.querySelector('[data-display-mode="videowall"]') !== null ||
            windowSize >= Theme.deviceValue.videowall;
        let size;
        if (isVideowallMode) {
            const vwPx = parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--vw')
            ) || 38.4;
            const vwScale = vwPx / 38.4;
            const basePx = parseFloat(Theme.icons.videowall[rest.iconSize]);
            size = String(Math.round(basePx * vwScale));
        } else if (windowSize >= Theme.deviceValue.desktop) {
            size = Theme.icons.desktop[rest.iconSize]
        } else if (windowSize >= Theme.deviceValue.laptop) {
            size = Theme.icons.laptop[rest.iconSize]
        } else if (windowSize >= Theme.deviceValue.tablet) {
            size = Theme.icons.tablet[rest.iconSize]
        } else {//(windowSize < '480px')
            size = Theme.icons.mobile[rest.iconSize]
        }

        let Component = IconsLibrary[icon];
        if (Component && typeof Component !== 'undefined') {
            return <Component {...rest} size={size} />;
        }

        console.error('ERROR: SVG icon (' + icon + ') does not exist');
        return null;
    }

    console.error('ERROR: icon props is missing');
    return null;
};

export default CustomIcon;
